import React from "react";

import useStyles from "@hooks/useStyles";
import useConstants from "@hooks/useConstants";
import useScrollTrigger from "@material-ui/core/useScrollTrigger";
import useStores from "@hooks/useStores";

import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";

import Slide from "@material-ui/core/Slide";

import TextField from "@components/Global/Custom/TextField";
import Autocomplete from "@components/Global/Custom/Autocomplete";

const ProBar = () => {
	const classes = useStyles("Pro");
	const { proStore: store } = useStores();

	const {
		serviceInputPlaceholder,
		serviceInputPlaceholderSlide,
		h2,
		h2short,
		cta,
	} = useConstants("ProBannerViewModel");

	const trigger = useScrollTrigger({
		threshold: 600,
		disableHysteresis: true,
	});

	const serviceOnSelectHandler = (service) => store.update("service", service);
	const zipcodeOnChangeHandler = (e) => store.update("zipcode", e.target.value);
	const getStartedHandler = (groupId) => (e) => {
		e.preventDefault();
		store.showSignupFunnel(groupId);
	};

	return (
		<Slide direction={{ xs: "up", sm: "down" }} in={trigger}>
			<Box
				position={"fixed"}
				p={4}
				left={0}
				right={0}
				top={{ xs: "inherit", sm: 0 }}
				bottom={{ xs: 0, sm: "inherit" }}
				width={"100%"}
				bgcolor={"#FFF"}
				zIndex={1200}
				boxShadow={4}
			>
				<Container maxWidth={false} className={classes.proContainer}>
					<form onSubmit={getStartedHandler("sticky")}>
						<Grid container spacing={4}>
							<Grid item xs={12} sm={6}>
								<Autocomplete
									onSelect={serviceOnSelectHandler}
									autoHighlight
									autoSelect
									id="service-sticky"
									searchOptions={{ midtail: false, active: true }}
									defaultValue={
										store.service?.name_proper || store.service?.name || ""
									}
									TextFieldProps={{
										groupId: "sticky",
										inputProps: {
											"autoCorrect": "off",
											"spellCheck": "false",
											"aria-label": "Enter service",
										},
										InputProps: {
											classes: {
												adornedStart: classes.autocompleteAdornedStart,
												input: classes.autocompleteInputRoot,
											},
										},
										placeholder: serviceInputPlaceholderSlide,
										variant: "outlined",
										name: "service",
									}}
								/>
							</Grid>

							<Grid item xs={6} sm={3}>
								<TextField
									groupId={"sticky"}
									type={"zipcode"}
									disableErrorText
									onChange={zipcodeOnChangeHandler}
									variant={"outlined"}
									fullWidth
									defaultValue={store.zipcode}
									id={"zip-sticky"}
									name={"zip"}
								/>
							</Grid>

							<Grid item xs={6} sm={3}>
								<Button
									fullWidth
									size={"large"}
									variant="contained"
									color="primary"
									disableElevation
									type={"submit"}
									className={classes.joinButton}
								>
									{cta}
								</Button>
							</Grid>
						</Grid>
					</form>
				</Container>
			</Box>
		</Slide>
	);
};

ProBar.propTypes = {};
export default ProBar;
